import { z } from 'zod/v4';
import { absoluteTimeRangeSchema } from './utils';

/**
 * Zod schema for HeatMapTimeSeriesDataResponse.
 *
 * HeatMapTimeSeriesData contains a timeRange field with Date objects that need
 * to be deserialized when loading from snapshots.
 */

const histogramBucketSchema = z.object({
  count: z.number(),
  upperBound: z.number(),
  lowerBound: z.number(),
});

const histogramSchema = z.object({
  timestamp: z.number(), // UnixTimeMs
  buckets: z.array(histogramBucketSchema),
});

export const heatMapTimeSeriesDataSchema = z.object({
  heatmap: z.array(histogramSchema),
  metadata: z.any().optional(),
  timeRange: absoluteTimeRangeSchema.optional(), // ← Date deserialization happens here
  stepMs: z.number().optional(),
});

export const heatMapTimeSeriesDataResponseSchema = z.object({
  type: z.literal('HeatMap'),
  data: heatMapTimeSeriesDataSchema,
});

export type HeatMapTimeSeriesDataResponseSchema = z.infer<typeof heatMapTimeSeriesDataResponseSchema>;
